import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from 'src/app/utils/modal/modal.component';

@Component({
    selector: 'app-instruction-modal',
    templateUrl: './instruction-modal.component.html',
    styleUrls: ['./instruction-modal.component.scss'],
    standalone: false
})
export class InstructionModalComponent implements OnInit {

  exStates = [ 'ready', 'locked', 'bad', 'enough', 'good', 'perfect']

  // Score ranges are numeric, so they are kept out of the translations
  scoreRanges: { [state: string]: string } = {
    bad: '(0-49%)',
    enough: '(50-74%)',
    good: '(75-84%)',
    perfect: '(85-100%)'
  }

  @ViewChild("instructionModal", {static: true})
  instructionModal: ModalComponent;

  @Input() sectionPath: string;
  @Input() exerciseName: string;
  @Input() showCompletedState: boolean = false;

  constructor() { }

  ngOnInit(): void { }

  getExStates() {
    if (this.sectionPath !== 'exams') {
      return this.exStates
    }
    const examStates = ['ready']
    if (this.showCompletedState) {
      examStates.push('completed')
    }
    return examStates
  }

  show(){
    this.instructionModal.show()
  }
}
